import styled from 'styled-components';

import {
  device,
  doublePadding,
  hexToRGB,
  padding,
  ScreenSize,
  typography,
} from '@/styles/helpers';

interface PromotionContentTitleProps {
  sub?: boolean;
}

interface ScPromotionProps {
  small?: boolean;
}

export const ScPromotion = styled.div<ScPromotionProps>`
  width: 100%;
  height: 400px;
  position: relative;

  background-color: ${({ theme }) => theme.blackColor};

  & > .slider-bg {
    object-fit: cover;
  }

  & > div {
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;

    .characters {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      max-height: calc(100% - 72px);

      & > img {
        object-fit: contain;
        object-position: right;
      }
    }
  }

  @media (${device.mobile}) {
    height: ${({ small }) => (small ? '405px' : '492px')} ;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.88) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 0;

    & > div {
      flex-direction: column;
      justify-content: flex-end;
      padding-top: 24px;

      @media (${device.mobile}) {
        padding: 0px 16px 44px 16px;
      }

      .characters {
        right: auto;
        bottom: auto;
        left: 50%;
        top: 56px;
        transform: translateX(-50%);
        order: 1;
        max-width: 375px;
        max-height: 260px;

        & > img {
          object-position: center;
        }
      }
    }
  }
`;

export const ScPromotionContentContainer = styled.div`
  max-width: ${ScreenSize.DESKTOP_L + doublePadding}px;
  width: 100%;
  padding: 0 ${padding}px;
  margin: 0 auto;

  @media (${device.desktop}) {
    max-width: ${ScreenSize.DESKTOP + doublePadding}px;
    padding: 0 ${padding}px;
  }

  @media (${device.tablet}) {
    max-width: ${ScreenSize.TABLET + doublePadding}px;
  }

  @media (${device.mobile}) {
    width: 100%;
    padding: 0px;
  }
`;

export const ScPromotionContent = styled.div`
  width: 100%;
  max-width: 544px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => hexToRGB(theme.blackColor, 0.55)};
  backdrop-filter: blur(12px);
  border-radius: 24px;
  margin: 72px 0 24px;
  z-index: 3;

  @media (${device.desktop}) {
    max-width: 352px;
    padding: 16px;
  }

  @media (${device.mobile}) {
    padding: 16px;
    transform: none;
    position: static;
    order: 2;
    margin: 0;
    width: 100%;
    max-width: none;
  }
`;

export const ScPromotionContentTitle = styled.div<PromotionContentTitleProps>`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme, sub }) => (sub ? theme.mainColor : theme.secondaryColor)};
  letter-spacing: 0.01em;
  text-transform: uppercase;
  text-align: center;
  max-width: 90%;
  margin-bottom: 16px;

  @media (${device.mobile}) {
    ${typography['caption1bold']};
    margin-bottom: 8px;
  }
`;

export const ScPromotionContentCenter = styled.div`
  text-align: center;
  max-width: 320px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;

  .description {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;

    text-transform: uppercase;
    font-weight: 700;
    ${typography['headline1']};

    @media (${device.mobile}) {
      ${typography['headline2mobile']};
      line-height: 28px;

      &.big-fs {
        font-size: 20px;
        line-height: 26px;
      }
    }
  }

  .subDescription {
    margin-top: 4px;
    ${typography['body2regular']};
    @media (${device.mobile}) {
      margin-top: 8px;
      font-size: 14px;
      line-height: 15px;
    }
  }

  @media (${device.mobile}) {
    max-width: 312px;
    margin-bottom: 20px;
  }
`;

export const ScPromotionContentBottom = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  .button {
    width: 280px;
  }

  @media (max-width: 544px) {
    .button {
      width: 100%;
      max-width: 318px;
    }
  }
`;
